// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"776cdcf3","203":"bae1a8ff","268":"f301f0ee","504":"cd28e833","557":"a760853e","596":"74b312b0","746":"1b41812e"}[chunkId] + ".chunk.js";
};